import React, { PureComponent } from 'react';
import { css, cx } from '@emotion/css';
import { theme } from '@branchjs/neo-components';
import type { DropdownProps } from '../Dropdown';
import Dropdown from '../Dropdown';
import customComponents from './customComponents';
const styles = {
  dropdownContainer: css({
    maxWidth: '200px',
    minWidth: '125px',
    marginBottom: '25px',
  }),
};
const customStyles = {
  control: (providedStyling) => ({
    ...providedStyling,
    boxSizing: 'border-box',
    border: `1px solid ${theme.colors.gray.neutral}`,
    borderRadius: '8px',
    backgroundColor: theme.colors.primary.contrastWhite,
  }),
  singleValue: (providedStyling) => ({ ...providedStyling, paddingLeft: '6px' }),
};

class DeviceDropdown extends PureComponent<DropdownProps> {
  render() {
    const { testid, outerClassName, ...dropdownProps } = this.props;
    return (
      <Dropdown
        {...dropdownProps}
        testid={`${testid}__device-dropdown`}
        outerClassName={cx(styles.dropdownContainer, outerClassName)}
        styles={customStyles}
        components={customComponents}
      />
    );
  }
}

export default DeviceDropdown;
